import React from "react";

import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    FileInput,
    FileField
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import BackButton from "./BackButton";

const DisciplineCreate = (props) => {
    const grades = [
        { id: 0, name: 'Grade R' },
        { id: 1, name: 'Grade 1' },
        { id: 2, name: 'Grade 2' },
        { id: 3, name: 'Grade 3' },
        { id: 4, name: 'Grade 4' },
        { id: 5, name: 'Grade 5' },
        { id: 6, name: 'Grade 6' },
        { id: 7, name: 'Grade 7' },
    ];

    return (
        <Create {...props} title="Create discipline record" redirect="list">
            <SimpleForm>
                <SelectInput source="grade" choices={grades} />
                <TextInput source="title" />
                <RichTextInput source="description" />
                <FileInput source="media" multiple={false}>
                    <FileField source="src" title="title" />
                </FileInput>
            </SimpleForm>
            <BackButton />
        </Create>
    );
};

export default DisciplineCreate;
